var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"headline",class:{ 'show-border': _vm.showBottomBorder }},[_c('span',{staticClass:"main-title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"right"},[_vm._t("right")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }